import { FC } from 'react';

interface IPrivateContentProps {
  title?: string;
}

const AuthRequired: FC<IPrivateContentProps> = (props) => {
  const { title } = props;
  return <>For Access to {title ?? 'This Content'} You need to Login</>;
};

export default AuthRequired;
